export default {"src":"/_next/static/media/loans.e2b2ff3b.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};